export default __webpack_public_path__ + "static/media/main.1e3c0e5a.jpg";